<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [title]="'Edit Property'"
      [class]="extraClass"
      [canGoBack]="true"
      [showLinkIcon]="true"
      [linkIcon]="'trash'"
      (linkAction)="deleteAddress()" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>
    @if (loaded) {
      <form [formGroup]="form" novalidate action="#">
        <tidy-row [align]="'center'">
          <tidy-row>
            <tidy-tag
              [color]="address?.color"
              [addressId]="address?.id" />
            <tidy-text
              [header]="address?.address1 + ' '"
              [translate]="false" />
            @if (address?.address2 !== null) {
              <tidy-text
                [header]="address?.address2 + ' '"
                [translate]="false" />
            }
            <tidy-text
              [header]="address?.city +
              ', ' +
              address?.zip"
              [translate]="false" />
          </tidy-row>
        </tidy-row>
        <tidy-row [alignLastItemRight]="true">
          <tidy-row [alignLastItemRight]="true" class="full-width">
            <tidy-text
              [body]="'Edit Order'" />
          </tidy-row>
          <tidy-toggle
            [toggled]="isReordering"
            (toggleChanged)="isReordering = !isReordering"
            class="extra-left-margin" />
        </tidy-row>
        @if (isReordering) {
          <div cdkDropListGroup>
            <ion-row>
              <ion-col>
                <div
                  cdkDropList
                  [cdkDropListData]="columns[0].items"
                  class="example-list"
                  (cdkDropListDropped)="drop($event)">
                  @for (item of columns[0].items; track item) {
                    <div cdkDrag class="drag-item">
                      <tidy-card>
                        <tidy-row [alignLastItemRight]="true">
                          <tidy-image [src]="item.icon" class="title-size" />
                          <tidy-text [header]="item.name" />
                          <div></div>
                        </tidy-row>
                      </tidy-card>
                    </div>
                  }
                </div>
              </ion-col>
              <ion-col>
                <div
                  cdkDropList
                  [cdkDropListData]="columns[1].items"
                  class="example-list"
                  (cdkDropListDropped)="drop($event)">
                  @for (item of columns[1].items; track item) {
                    <div cdkDrag class="drag-item">
                      <tidy-card>
                        <tidy-row [alignLastItemRight]="true">
                          <tidy-image [src]="item.icon" class="title-size" />
                          <tidy-text [header]="item.name" />
                          <div></div>
                        </tidy-row>
                      </tidy-card>
                    </div>
                  }
                </div>
              </ion-col>
            </ion-row>
          </div>
        }
        @if (!isReordering) {
          <tidy-card>
            <tidy-row>
              <tidy-input
                formControlName="addressNickname"
                [form]="form.controls.addressNickname"
                [label]="'Property Nickname (optional)'"
                [icon]="'assets/svg/information-circle.svg'" />
            </tidy-row>
            <tidy-row>
              <tidy-select
                [icon]="'assets/svg/home.svg'"
                [label]="'Build Type'"
                [items]="buildTypeItems"
                [form]="form.controls.buildType"
                formControlName="buildType"
                [errorMessage]="'Please enter a build type.'"
                [submitted]="submitted" />
            </tidy-row>
            <tidy-row>
              <tidy-select
                [icon]="'assets/svg/information-circle.svg'"
                [label]="'Roof Type'"
                [items]="roofTypeItems"
                [form]="form.controls.roofType"
                formControlName="roofType"
                [errorMessage]="'Please enter a roof type.'"
                [submitted]="submitted" />
            </tidy-row>
            <tidy-row>
              <tidy-input
                [label]="'Square Feet'"
                formControlName="squareFeet"
                [form]="form.controls.squareFeet"
                [icon]="'assets/svg/expand.svg'"
                [inputMode]="'numeric'"
                [submitted]="submitted"
                [errorMessage]="'Please enter the square feet.'" />
            </tidy-row>
          </tidy-card>
          <tidy-error-message
            [text]="errorMessage" />
          <tidy-button
            [text]="'Save'"
            class="primary"
            [action]="boundSave" />

          @if (isRightSideContent) {
            <tidy-row [align]="'center'" class="extra-top-padding">
              <tidy-text
                class="link red"
                [body]="'Delete Property'"
                (action)="deleteAddress()" />
            </tidy-row>
          }
        }
      </form>
    }
  </tidy-wrapper>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
